<template>
  <div class="com">
    <div class="input-wrap">
      <input
        v-mask="'XX - XX - XXX - XXXX'"
        id="kit-id"
        type="text"
        class="input"
        placeholder="Enter Kit ID"
        v-model="enterKit"
        @paste="paste"
        name="kit_id"
        :class="{ invalid: errors.has('kit_id') }"
        v-validate="{ required: true, length: 20 }"
      />
      <span class="validate-error" v-if="errors.has('kit_id') && !errorCase">
        {{ setError(errors.first("kit_id")) }} 
      </span>
      <span class="validate-error" v-else-if="errors.has('kit_id') && errorCase == 'archived'">
        This Kit ID has been archived. Please
        <a :href="contact_link" target="_blank" class="login-link">contact support.</a>
      </span>
      <span class="validate-error" v-else-if="errorCase == 'validation'">
        This Kit ID is not available. Please 
        <a :href="contact_link" target="_blank" class="login-link">contact support.</a>
      </span>
    </div>
    <div class="input-wrap">
      <input
        v-mask="'XX - XX - XXX - XXXX'"
        id="kit-verify"
        type="text"
        class="input"
        @paste="paste"
        @change="validate"
        placeholder="Confirm Kit ID"
        v-model="verifyKit"
        name="confirm_kit_id"
        v-validate="{ required: true, is: enterKit }"
      />
      <span
        class="validate-error bottom-position"
        v-if="errors.has('confirm_kit_id')"
      >
        {{ errors.first("confirm_kit_id") }}
      </span>
    </div>
    <button
      class="btn"
      @click.prevent="$validator.validateAll()"
      @click="switchStep"
      :disabled="!isComplete"
    >
      Continue
    </button>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { parseAndConvertKitId } from "../../mixins/parseAndConvertKitId";

export default {
  name: "ActivateKir",
  mixins: [parseAndConvertKitId],
  directives: { mask },
  data() {
    return {
      verifyKit: null,
      enterKit: null,
      errorCase: false,
      contact_link: 'https://www.gotmold.com/#contact-us',
    };
  },
  computed: {
    ...mapGetters(["serverValidation"]),
    isComplete() {
      return (
        this.verifyKit && this.enterKit && this.verifyKit === this.enterKit
      );
    }
  },

  watch: {
    serverValidation(error) {
      error.forEach(item => {
        this.$validator.errors.add({ field: item.field, msg: item.message });
      });
      if(this.serverValidation.length > 0 && (this.serverValidation[0].message == 'exists validation failed on kit_id' || this.serverValidation[0].message == 'Kit ID already registered. Sign in!')) {
        this.errorCase = 'validation';
      } else if(this.serverValidation.length > 0 && this.serverValidation[0].message == 'This Kit has been archived') {
        this.errorCase = 'archived';
      } else {
        this.errorCase = false;
      }
    },
    verifyKit() {
      this.verifyKit = this.verifyKit.toUpperCase();
    },
    enterKit() {
      this.enterKit = this.enterKit.toUpperCase();
    }
  },
  methods: {
    setError(str) { 
      return str;
    },
    paste(e) {
      e.preventDefault();
    },
    validate() {
      this.errors.clear();
    },
    ...mapActions(["userInfo", "checkKitIdProfile"]),
    switchStep() {
      if (this.errors.any() || !this.isComplete) {
        return;
      }
      const kitId = {
        kit_id: this.parseKitId(this.enterKit),
        kit_id_confirmation: this.parseKitId(this.verifyKit)
      };
      this.checkKitIdProfile(kitId).then(res => {
          this.$emit("nextStep", 1);
          this.$emit("kitId", {'enterKit':this.parseKitId(this.enterKit),'verifyKit':this.parseKitId(this.verifyKit)});
      });
    }
  },
  mounted() {
    if (localStorage.getItem("actkitid")) {
      this.verifyKit = localStorage.getItem("actkitid");
      this.enterKit = localStorage.getItem("actkitid");
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
.com {
  margin: 36px 0 0 0;
}
.input {
  padding: 17px 20px;
  border-radius: 10px;
  border: 1px solid #c5c5c5;
  color: $gray;
  width: 100%;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
  outline: none;
  font-family: TTNormsMedium, sans-serif;
}
.input::placeholder {
  color: $lightGray;
  font-size: 16px;
  text-align: center;
  text-transform: none;
  font-family: TTNormsMedium, sans-serif;
}
.input-wrap {
  margin: 0 0 20px;
  position: relative;
}
.input.invalid {
  border: 1px solid $red;
}
.bottom-position {
  bottom: -22px;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  transition: all 0.5s linear;
  font-size: 18px;
  font-family: TTNormsBold, sans-serif;
}
.login-link {
  color: #005eb8;
}
</style>
